import Material from "@domain/model/Material";
import { useEffect, useRef, useState } from "react";
import { LastPageState } from "@domain/model/LastPageState";
import { useListDetailPaginatedViewModel } from "@movicoders/ui";
import { ILastPageService } from "@domain/services/ILastPageService";
import { ListMaterialsPaginatedRequest } from "@clients/aggrego-proxy";
import { MaterialRepository } from "@infrastructure/repositories/material-repository";

export const useInventoryReportAutocomplete = (
  currentPageService: ILastPageService,
  currentPagePersistedState: LastPageState
) => {
  const { data: materialPaginatedData, getPaginated: getMaterialPaginated } = useListDetailPaginatedViewModel(MaterialRepository);
  const getMaterialPaginatedForFilter = useRef(getMaterialPaginated).current;
  const [filteredMaterialPaginatedData, setFilteredMaterialPaginatedData] = useState<Material[]>([]);

  useEffect(() => {
    if (currentPagePersistedState.autocompleteFilterText !== undefined && !currentPagePersistedState.autocompleteFilterLoading) {
      currentPageService.saveLastPageState({ ...currentPagePersistedState, autocompleteFilterLoading: true });
      getMaterialPaginatedForFilter({
        xTenantId: "",
        limit: 10,
        offset: 0,
        fullDTO: false,
        customMaterialFilter: {
          ...currentPagePersistedState.filters,
          searchText: currentPagePersistedState.autocompleteFilterText
        }
      } as ListMaterialsPaginatedRequest).finally(() => {
        currentPageService.saveLastPageState({
          ...currentPagePersistedState,
          autocompleteFilterText: undefined,
          autocompleteFilterLoading: false
        });
      });
    }
  }, [currentPagePersistedState.autocompleteFilterText]);

  useEffect(() => {
    setFilteredMaterialPaginatedData(
      (materialPaginatedData.content as unknown as Material[])?.filter(material =>
        material.code.toLowerCase().includes(currentPagePersistedState.autocompleteFilterText?.toLowerCase() ?? "")
      )
    );
  }, [materialPaginatedData]);

  return {
    filteredMaterialPaginatedData
  };
};
